import React from 'react';
import { AdminFormFieldRow } from './AdminFormFieldRow';
import {
  SITE_ARRIVAL_SECTION_DORM_RENTALS,
  SITE_ARRIVAL_SECTION_HEALTH_CHECKUP,
  SITE_ARRIVAL_SECTION_MEALS,
} from './siteArrivalConfirmationAdminLayout';
import { formatIsoDate } from '../../../employee/fillingForms/chat/siteArrivalConfirmation/siteArrivalConfirmationDisplay';
import './ProfileSectionPreview.css';

function fieldChanged(
  values: Record<string, string>,
  snapshotValues: Record<string, string> | undefined,
  key: string
): boolean {
  if (!snapshotValues || !(key in snapshotValues)) return false;
  return (values[key] ?? '') !== (snapshotValues[key] ?? '');
}

function formatSuruShinai(raw: string): string {
  const v = raw.trim().toLowerCase();
  if (v === 'yes' || v === 'true') return 'する';
  if (v === 'no' || v === 'false') return 'しない';
  return raw.trim() || '—';
}

function YesNoSuruShinaiRow({
  label,
  fieldKey,
  values,
  snapshotValues,
  editing,
  onChange,
}: {
  label: string;
  fieldKey: string;
  values: Record<string, string>;
  snapshotValues?: Record<string, string>;
  editing: boolean;
  onChange: (key: string, value: string) => void;
}) {
  const raw = values[fieldKey] ?? '';
  return (
    <AdminFormFieldRow
      label={label}
      value={formatSuruShinai(raw)}
      editing={editing}
      changed={fieldChanged(values, snapshotValues, fieldKey)}
      compareValue={
        snapshotValues?.[fieldKey] != null ? formatSuruShinai(snapshotValues[fieldKey]) : undefined
      }
    >
      <select
        className="profile-section-preview__input"
        value={raw}
        onChange={(e) => onChange(fieldKey, e.target.value)}
      >
        <option value="">—</option>
        <option value="yes">する</option>
        <option value="no">しない</option>
      </select>
    </AdminFormFieldRow>
  );
}

export function SiteArrivalConfirmationAdminFieldEditor({
  values,
  editing,
  onChange,
  snapshotValues,
}: {
  values: Record<string, string>;
  editing: boolean;
  onChange: (key: string, value: string) => void;
  snapshotValues?: Record<string, string>;
}) {
  const healthCheckupDate = values.healthCheckupDate ?? '';
  const healthCheckupLocation = values.healthCheckupLocation ?? '';
  const rentOther = values.rentOther ?? '';

  return (
    <div className="profile-section-preview__content">
      <h3 className="profile-section-preview__section-title">{SITE_ARRIVAL_SECTION_HEALTH_CHECKUP}</h3>

      <AdminFormFieldRow
        label="日時"
        value={formatIsoDate(healthCheckupDate)}
        editing={editing}
        changed={fieldChanged(values, snapshotValues, 'healthCheckupDate')}
        compareValue={
          snapshotValues?.healthCheckupDate != null
            ? formatIsoDate(snapshotValues.healthCheckupDate)
            : undefined
        }
      >
        <input
          type="date"
          className="profile-section-preview__input"
          value={healthCheckupDate}
          onChange={(e) => onChange('healthCheckupDate', e.target.value)}
        />
      </AdminFormFieldRow>

      <AdminFormFieldRow
        label="場所"
        value={healthCheckupLocation}
        editing={editing}
        changed={fieldChanged(values, snapshotValues, 'healthCheckupLocation')}
        compareValue={snapshotValues?.healthCheckupLocation}
      >
        <input
          className="profile-section-preview__input"
          value={healthCheckupLocation}
          onChange={(e) => onChange('healthCheckupLocation', e.target.value)}
        />
      </AdminFormFieldRow>

      <h3 className="profile-section-preview__section-title">{SITE_ARRIVAL_SECTION_DORM_RENTALS}</h3>

      <YesNoSuruShinaiRow
        label="テレビ"
        fieldKey="rentTv"
        values={values}
        snapshotValues={snapshotValues}
        editing={editing}
        onChange={onChange}
      />
      <YesNoSuruShinaiRow
        label="布団"
        fieldKey="rentFuton"
        values={values}
        snapshotValues={snapshotValues}
        editing={editing}
        onChange={onChange}
      />
      <YesNoSuruShinaiRow
        label="冷蔵庫"
        fieldKey="rentFridge"
        values={values}
        snapshotValues={snapshotValues}
        editing={editing}
        onChange={onChange}
      />

      <AdminFormFieldRow
        label="その他"
        value={rentOther}
        editing={editing}
        changed={fieldChanged(values, snapshotValues, 'rentOther')}
        compareValue={snapshotValues?.rentOther}
      >
        <input
          className="profile-section-preview__input"
          value={rentOther}
          placeholder="希望するリース備品"
          onChange={(e) => onChange('rentOther', e.target.value)}
        />
      </AdminFormFieldRow>

      <h3 className="profile-section-preview__section-title">{SITE_ARRIVAL_SECTION_MEALS}</h3>

      <YesNoSuruShinaiRow
        label="朝"
        fieldKey="breakfast"
        values={values}
        snapshotValues={snapshotValues}
        editing={editing}
        onChange={onChange}
      />
      <YesNoSuruShinaiRow
        label="昼"
        fieldKey="lunch"
        values={values}
        snapshotValues={snapshotValues}
        editing={editing}
        onChange={onChange}
      />
      <YesNoSuruShinaiRow
        label="夕"
        fieldKey="dinner"
        values={values}
        snapshotValues={snapshotValues}
        editing={editing}
        onChange={onChange}
      />
    </div>
  );
}

export default SiteArrivalConfirmationAdminFieldEditor;
